import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import "babel-polyfill";

ReactDOM.render(<App />, document.getElementById('app'));
registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js